import { normalize } from 'normalizr';

import {
  ADD_SCHOOLS_SCHEDULING,
  SCHOOLS_SCHEDULING_API_REQUEST,
  SCHOOLS_SCHEDULING_API_SUCCESS,
  SCHOOLS_SCHEDULING_API_FAILURE,
} from './actionTypes';
import {
  FETCH_SCHEDULE_START,
  FETCH_SCHEDULE_SUCCESS,
  FETCH_SCHEDULE_ERROR,
  FETCH_APPOINTMENTS_START,
  FETCH_APPOINTMENTS_SUCCESS,
  FETCH_APPOINTMENTS_ERROR,
  FETCH_STUDENT_APPOINTMENTS_START,
  FETCH_STUDENT_APPOINTMENTS_SUCCESS,
  FETCH_STUDENT_APPOINTMENTS_ERROR,
  MAKE_APPOINTMENT_START,
  MAKE_APPOINTMENT_SUCCESS,
  MAKE_APPOINTMENT_ERROR,
  CANCEL_APPOINTMENT_START,
  CANCEL_APPOINTMENT_SUCCESS,
  CANCEL_APPOINTMENT_ERROR,
  UPDATE_APPOINTMENT_START,
  UPDATE_APPOINTMENT_SUCCESS,
  UPDATE_APPOINTMENT_ERROR,
  EXPRESS_INTEREST_START,
  EXPRESS_INTEREST_SUCCESS,
  EXPRESS_INTEREST_ERROR,
  NO_MATCHING_TIMESLOT_START,
  NO_MATCHING_TIMESLOT_SUCCESS,
  NO_MATCHING_TIMESLOT_ERROR,
  UNEXPRESS_INTEREST_START,
  UNEXPRESS_INTEREST_SUCCESS,
  UNEXPRESS_INTEREST_ERROR,
  FETCH_EXPRESSED_INTERESTS_START,
  FETCH_EXPRESSED_INTERESTS_SUCCESS,
  FETCH_EXPRESSED_INTERESTS_ERROR,
  FETCH_SHARED_SCHEDULE_START,
  FETCH_SHARED_SCHEDULE_SUCCESS,
  FETCH_SHARED_SCHEDULE_ERROR,
  FETCH_SHARED_SCHEDULE_GT_FILTERED_START,
  FETCH_SHARED_SCHEDULE_GT_FILTERED_SUCCESS,
  FETCH_SHARED_SCHEDULE_GT_FILTERED_ERROR,
  FETCH_SHARED_SCHEDULE_GT_FILTERED_LOCATIONS_START,
  FETCH_SHARED_SCHEDULE_GT_FILTERED_LOCATIONS_SUCCESS,
  FETCH_SHARED_SCHEDULE_GT_FILTERED_LOCATIONS_ERROR,
  SCHEDULE_COMPLETE_START,
  SCHEDULE_COMPLETE_SUCCESS,
  SCHEDULE_COMPLETE_ERROR,
  FETCH_NO_MATCHING_TIMESLOTS_START,
  FETCH_NO_MATCHING_TIMESLOTS_SUCCESS,
  FETCH_NO_MATCHING_TIMESLOTS_ERROR,
  REMOVE_NO_MATCHING_TIMESLOT_START,
  REMOVE_NO_MATCHING_TIMESLOT_SUCCESS,
  REMOVE_NO_MATCHING_TIMESLOT_ERROR,
  FETCH_EXPRESSED_INTERESTS_INSTRUMENTS_START,
  FETCH_EXPRESSED_INTERESTS_INSTRUMENTS_SUCCESS,
  FETCH_EXPRESSED_INTERESTS_INSTRUMENTS_ERROR,
} from '../constants';
import { apiToSchools, normalSchools } from './schools';
import fetchErrorHandler from '../services/fetchErrorHandler';
import { getCsrfToken } from '../utils/helpers';

const schoolsSchedulingApiRequest = () => ({
  type: SCHOOLS_SCHEDULING_API_REQUEST,
});

const schoolsSchedulingApiSuccess = () => ({
  type: SCHOOLS_SCHEDULING_API_SUCCESS,
});

const schoolsSchedulingApiFailure = ({ error }) => ({
  type: SCHOOLS_SCHEDULING_API_FAILURE,
  error,
});

const addSchoolsScheduling = ({ schools, page, normal }) => ({
  type: ADD_SCHOOLS_SCHEDULING,
  payload: {
    schools,
    page,
    normal,
  },
});

export const getSchoolsScheduling = (extra = '') => async (dispatch, getState, { fetch }) => {
  const { apiVersion } = getState().runtime;
  const { optionsDict } = getState().schools;
  const { locale } = getState().intl;
  const { applicationId } = getState().user;
  const url = `${locale}/api/${apiVersion}/application/${applicationId}/application-programs/schedule/schools${extra}`;
  let parametersUri = [];
  Object.entries(optionsDict).forEach(([key, value]) => {
    if (value.length > 0) {
      return value.map(e => parametersUri.push(`${encodeURIComponent(key)}=${encodeURIComponent(e)}`));
    }
    return false;
  });
  parametersUri = parametersUri.map(x => x).join('&');
  dispatch(schoolsSchedulingApiRequest());

  return fetch(`${url}?${parametersUri}`, {
    credentials: 'include',
    headers: {
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'X-CSRFToken': getCsrfToken(),
    },
  })
    .then(fetchErrorHandler)
    .then(resp => resp.json())
    .then(data => {
      let schools = '';
      if (!data.results) {
        schools = data.map(apiToSchools);
      } else {
        schools = data.results.map(apiToSchools);
      }
      const normal = normalize(schools, normalSchools);
      dispatch(
        addSchoolsScheduling({
          schools,
          normal,
        }),
      );
      dispatch(schoolsSchedulingApiSuccess());
    })
    .catch(error => {
      console.error('error', error);
      dispatch(schoolsSchedulingApiFailure({ error }));
    });
};

export const fetchSchedule = applicationId => async (dispatch, getState, { fetch }) => {
  const { apiVersion } = getState().runtime;
  const { locale } = getState().intl;
  dispatch({ type: FETCH_SCHEDULE_START });

  return fetch(`${locale}/api/${apiVersion}/application/${applicationId}/application-programs/schedule/`, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRFToken': getCsrfToken(),
    },
    method: 'GET',
  })
    .then(fetchErrorHandler)
    .then(response => {
      if (response.status === 200) {
        return response;
      }

      const error = new Error(response.statusText);
      error.response = response;
      throw error;
    })
    .then(response => response.json())
    .then(json => {
      dispatch({
        type: FETCH_SCHEDULE_SUCCESS,
        payload: json,
      });
    })
    .catch(error => {
      dispatch({
        type: FETCH_SCHEDULE_ERROR,
        payload: error,
      });
    });
};

export const fetchSharedSchedule = applicationId => async (dispatch, getState, { fetch }) => {
  dispatch({ type: FETCH_SHARED_SCHEDULE_START });

  const { apiVersion } = getState().runtime;
  const { locale } = getState().intl;
  return fetch(`${locale}/api/${apiVersion}/application/${applicationId}/application-programs/schedule/shared/`, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRFToken': getCsrfToken(),
    },
    method: 'GET',
  })
    .then(fetchErrorHandler)
    .then(response => {
      if (response.status === 200) {
        return response;
      }

      const error = new Error(response.statusText);
      error.response = response;
      throw error;
    })
    .then(response => response.json())
    .then(json => {
      dispatch({
        type: FETCH_SHARED_SCHEDULE_SUCCESS,
        payload: json,
      });
    })
    .catch(error => {
      dispatch({
        type: FETCH_SHARED_SCHEDULE_ERROR,
        payload: error,
      });
    });
};

export const fetchSharedScheduleGTFiltered = (applicationId, kwargs) => async (dispatch, getState, { fetch }) => {
  dispatch({ type: FETCH_SHARED_SCHEDULE_GT_FILTERED_START });

  const { apiVersion } = getState().runtime;
  let parametersUri = [];
  Object.entries(kwargs).forEach(([key, value]) => {
    parametersUri.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    return null;
  });
  parametersUri = parametersUri.map(x => x).join('&');
  const { locale } = getState().intl;
  return fetch(
    `${locale}/api/${apiVersion}/application/${applicationId}/application-programs/schedule/shared/?${parametersUri}`,
    {
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRFToken': getCsrfToken(),
      },
      method: 'GET',
    },
  )
    .then(fetchErrorHandler)
    .then(response => {
      if (response.status === 200) {
        return response;
      }

      const error = new Error(response.statusText);
      error.response = response;
      throw error;
    })
    .then(response => response.json())
    .then(json => {
      dispatch({
        type: FETCH_SHARED_SCHEDULE_GT_FILTERED_SUCCESS,
        payload: json,
      });
    })
    .catch(error => {
      dispatch({
        type: FETCH_SHARED_SCHEDULE_GT_FILTERED_ERROR,
        payload: error,
      });
    });
};

export const fetchSharedScheduleGTFilteredLocations = (applicationId, kwargs) => async (
  dispatch,
  getState,
  { fetch },
) => {
  dispatch({ type: FETCH_SHARED_SCHEDULE_GT_FILTERED_LOCATIONS_START });

  const { apiVersion } = getState().runtime;
  let parametersUri = [];
  Object.entries(kwargs).forEach(([key, value]) => {
    parametersUri.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    return null;
  });
  parametersUri = parametersUri.map(x => x).join('&');
  const { locale } = getState().intl;
  return fetch(
    `${locale}/api/${apiVersion}/application/${applicationId}/application-programs/schedule/shared/g-t-locations/?${parametersUri}`,
    {
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRFToken': getCsrfToken(),
      },
      method: 'GET',
    },
  )
    .then(fetchErrorHandler)
    .then(response => {
      if (response.status === 200) {
        return response;
      }

      const error = new Error(response.statusText);
      error.response = response;
      throw error;
    })
    .then(response => response.json())
    .then(json => {
      dispatch({
        type: FETCH_SHARED_SCHEDULE_GT_FILTERED_LOCATIONS_SUCCESS,
        payload: json,
      });
    })
    .catch(error => {
      dispatch({
        type: FETCH_SHARED_SCHEDULE_GT_FILTERED_LOCATIONS_ERROR,
        payload: error,
      });
    });
};

export const fetchAppointments = applicationId => async (dispatch, getState, { fetch }) => {
  dispatch({ type: FETCH_APPOINTMENTS_START });
  const { apiVersion } = getState().runtime;
  const { locale } = getState().intl;

  return fetch(`${locale}/api/${apiVersion}/application/${applicationId}/appointments/`, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRFToken': getCsrfToken(),
    },
    method: 'GET',
  })
    .then(fetchErrorHandler)
    .then(response => {
      if (response.status === 200) {
        return response;
      }

      const error = new Error(response.statusText);
      error.response = response;
      throw error;
    })
    .then(response => response.json())
    .then(json => {
      dispatch({
        type: FETCH_APPOINTMENTS_SUCCESS,
        payload: json,
      });
    })
    .catch(error => {
      dispatch({
        type: FETCH_APPOINTMENTS_ERROR,
        payload: error,
      });
    });
};

export const fetchStudentAppointments = applicationId => async (dispatch, getState, { fetch }) => {
  dispatch({ type: FETCH_STUDENT_APPOINTMENTS_START });
  const { apiVersion } = getState().runtime;
  const { locale } = getState().intl;

  return fetch(`${locale}/api/${apiVersion}/application/${applicationId}/appointments/all-for-student/`, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRFToken': getCsrfToken(),
    },
    method: 'GET',
  })
    .then(fetchErrorHandler)
    .then(response => {
      if (response.status === 200) {
        return response;
      }

      const error = new Error(response.statusText);
      error.response = response;
      throw error;
    })
    .then(response => response.json())
    .then(json => {
      dispatch({
        type: FETCH_STUDENT_APPOINTMENTS_SUCCESS,
        payload: json,
      });
    })
    .catch(error => {
      dispatch({
        type: FETCH_STUDENT_APPOINTMENTS_ERROR,
        payload: error,
      });
    });
};

export const fetchExpressedInterests = applicationId => async (dispatch, getState, { fetch }) => {
  dispatch({ type: FETCH_EXPRESSED_INTERESTS_START });
  const { apiVersion } = getState().runtime;
  const { locale } = getState().intl;

  return fetch(`${locale}/api/${apiVersion}/application/${applicationId}/expressions-of-interest/`, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRFToken': getCsrfToken(),
    },
    method: 'GET',
  })
    .then(fetchErrorHandler)
    .then(response => {
      if (response.status === 200) {
        return response;
      }

      const error = new Error(response.statusText);
      error.response = response;
      throw error;
    })
    .then(response => response.json())
    .then(json => {
      dispatch({
        type: FETCH_EXPRESSED_INTERESTS_SUCCESS,
        payload: json,
      });
    })
    .catch(error => {
      dispatch({
        type: FETCH_EXPRESSED_INTERESTS_ERROR,
        payload: error,
      });
    });
};

export const fetchExpressedInterestsInstruments = () => async (dispatch, getState, { fetch }) => {
  const { locale } = getState().intl;
  const { apiVersion } = getState().runtime;

  dispatch({ type: FETCH_EXPRESSED_INTERESTS_INSTRUMENTS_START });

  return fetch(`${locale}/api/${apiVersion}/instruments/`, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRFToken': getCsrfToken(),
    },
    method: 'GET',
  })
    .then(fetchErrorHandler)
    .then(response => {
      if (response.status === 200) {
        return response;
      }

      const error = new Error(response.statusText);
      error.response = response;
      throw error;
    })
    .then(response => response.json())
    .then(json => {
      dispatch({
        type: FETCH_EXPRESSED_INTERESTS_INSTRUMENTS_SUCCESS,
        payload: json,
      });
    })
    .catch(error => {
      dispatch({
        type: FETCH_EXPRESSED_INTERESTS_INSTRUMENTS_ERROR,
        payload: error,
      });
    });
};

export const fetchNoMatchingTimeSlots = applicationId => async (dispatch, getState, { fetch }) => {
  dispatch({ type: FETCH_NO_MATCHING_TIMESLOTS_START });
  const { apiVersion } = getState().runtime;
  const { locale } = getState().intl;

  return fetch(`${locale}/api/${apiVersion}/application/${applicationId}/no-matching-timeslot/`, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRFToken': getCsrfToken(),
    },
    method: 'GET',
  })
    .then(fetchErrorHandler)
    .then(response => {
      if (response.status === 200) {
        return response;
      }

      const error = new Error(response.statusText);
      error.response = response;
      throw error;
    })
    .then(response => response.json())
    .then(json => {
      dispatch({
        type: FETCH_NO_MATCHING_TIMESLOTS_SUCCESS,
        payload: json,
      });
    })
    .catch(error => {
      dispatch({
        type: FETCH_NO_MATCHING_TIMESLOTS_ERROR,
        payload: error,
      });
    });
};

export const makeAppointment = (applicationId, data) => async (dispatch, getState, { fetch }) => {
  dispatch({ type: MAKE_APPOINTMENT_START });
  const { apiVersion } = getState().runtime;
  const { locale } = getState().intl;

  return fetch(`${locale}/api/${apiVersion}/application/${applicationId}/appointments/`, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRFToken': getCsrfToken(),
    },
    method: 'POST',
    body: JSON.stringify(data),
  })
    .then(fetchErrorHandler)
    .then(response => {
      if (response.status === 201) {
        return response;
      }

      const error = new Error(response.statusText);
      error.response = response;
      throw error;
    })
    .then(response => response.json())
    .then(json => {
      dispatch({
        type: MAKE_APPOINTMENT_SUCCESS,
        payload: json,
      });
    })
    .catch(error => {
      dispatch({
        type: MAKE_APPOINTMENT_ERROR,
        payload: error,
      });
    });
};

export const cancelAppointment = (applicationId, appointmentId) => async (dispatch, getState, { fetch }) => {
  dispatch({ type: CANCEL_APPOINTMENT_START });
  const { apiVersion } = getState().runtime;
  const { locale } = getState().intl;

  return fetch(`${locale}/api/${apiVersion}/application/${applicationId}/appointments/${appointmentId}`, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRFToken': getCsrfToken(),
    },
    method: 'DELETE',
  })
    .then(fetchErrorHandler)
    .then(response => {
      if (response.status === 204) {
        dispatch({
          type: CANCEL_APPOINTMENT_SUCCESS,
          payload: { id: appointmentId },
        });
        return;
      }

      const error = new Error(response.statusText);
      error.response = response;
      throw error;
    })
    .catch(error => {
      dispatch({
        type: CANCEL_APPOINTMENT_ERROR,
        payload: error,
      });
    });
};

export const updateAppointment = (applicationId, data) => async (dispatch, getState, { fetch }) => {
  dispatch({ type: UPDATE_APPOINTMENT_START });
  const { apiVersion } = getState().runtime;
  const { locale } = getState().intl;
  const appointmentId = data.appointment_id;

  return fetch(`${locale}/api/${apiVersion}/application/${applicationId}/appointments/${appointmentId}/re-schedule/`, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRFToken': getCsrfToken(),
    },
    method: 'POST',
    body: JSON.stringify(data),
  })
    .then(fetchErrorHandler)
    .then(response => {
      if (response.status === 201) {
        return response;
      }

      const error = new Error(response.statusText);
      error.response = response;
      throw error;
    })
    .then(response => response.json())
    .then(json => {
      dispatch({
        type: UPDATE_APPOINTMENT_SUCCESS,
        payload: json,
        oldId: appointmentId,
      });
    })
    .catch(error => {
      dispatch({
        type: UPDATE_APPOINTMENT_ERROR,
        payload: error,
      });
    });
};

export const expressInterest = (applicationId, data) => async (dispatch, getState, { fetch }) => {
  dispatch({ type: EXPRESS_INTEREST_START });
  const { apiVersion } = getState().runtime;
  const { locale } = getState().intl;

  return fetch(`${locale}/api/${apiVersion}/application/${applicationId}/expressions-of-interest/`, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRFToken': getCsrfToken(),
    },
    method: 'POST',
    body: JSON.stringify(data),
  })
    .then(fetchErrorHandler)
    .then(response => {
      if (response.status === 201) {
        return response;
      }

      const error = new Error(response.statusText);
      error.response = response;
      throw error;
    })
    .then(response => response.json())
    .then(json => {
      dispatch({
        type: EXPRESS_INTEREST_SUCCESS,
        payload: json,
      });
    })
    .catch(error => {
      dispatch({
        type: EXPRESS_INTEREST_ERROR,
        payload: error,
      });
    });
};

export const flagNoMatchingTimeslot = (applicationId, data, accommodation504) => async (
  dispatch,
  getState,
  { fetch },
) => {
  dispatch({ type: NO_MATCHING_TIMESLOT_START });
  const { apiVersion } = getState().runtime;
  const { locale } = getState().intl;

  let url = `${locale}/api/${apiVersion}/application/${applicationId}/no-matching-timeslot/`;
  if (accommodation504) {
    url += '?flag_504=true';
  }

  return fetch(url, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRFToken': getCsrfToken(),
    },
    method: 'POST',
    body: JSON.stringify(data),
  })
    .then(fetchErrorHandler)
    .then(response => {
      if (response.status === 201) {
        return response;
      }

      const error = new Error(response.statusText);
      error.response = response;
      throw error;
    })
    .then(response => response.json())
    .then(json => {
      dispatch({
        type: NO_MATCHING_TIMESLOT_SUCCESS,
        payload: json,
      });
    })
    .catch(error => {
      dispatch({
        type: NO_MATCHING_TIMESLOT_ERROR,
        payload: error,
      });
    });
};

export const removeNoMatchingTimeSlot = (applicationId, noMatchingTimeSlotId) => async (
  dispatch,
  getState,
  { fetch },
) => {
  dispatch({ type: REMOVE_NO_MATCHING_TIMESLOT_START });
  const { apiVersion } = getState().runtime;
  const { locale } = getState().intl;

  return fetch(
    `${locale}/api/${apiVersion}/application/${applicationId}/no-matching-timeslot/${noMatchingTimeSlotId}`,
    {
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRFToken': getCsrfToken(),
      },
      method: 'DELETE',
    },
  )
    .then(fetchErrorHandler)
    .then(response => {
      if (response.status === 204) {
        dispatch({
          type: REMOVE_NO_MATCHING_TIMESLOT_SUCCESS,
          payload: { id: noMatchingTimeSlotId },
        });
        return;
      }

      const error = new Error(response.statusText);
      error.response = response;
      throw error;
    })
    .catch(error => {
      dispatch({
        type: REMOVE_NO_MATCHING_TIMESLOT_ERROR,
        payload: error,
      });
    });
};

export const unexpressInterest = (applicationId, expressionOfInterestId) => async (dispatch, getState, { fetch }) => {
  dispatch({ type: UNEXPRESS_INTEREST_START });
  const { apiVersion } = getState().runtime;
  const { locale } = getState().intl;

  return fetch(
    `${locale}/api/${apiVersion}/application/${applicationId}/expressions-of-interest/${expressionOfInterestId}`,
    {
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRFToken': getCsrfToken(),
      },
      method: 'DELETE',
    },
  )
    .then(fetchErrorHandler)
    .then(response => {
      if (response.status === 204) {
        dispatch({
          type: UNEXPRESS_INTEREST_SUCCESS,
          payload: { id: expressionOfInterestId },
        });
        return;
      }

      const error = new Error(response.statusText);
      error.response = response;
      throw error;
    })
    .catch(error => {
      dispatch({
        type: UNEXPRESS_INTEREST_ERROR,
        payload: error,
      });
    });
};

export const resetForm = type => dispatch => dispatch({ type });

export const schedulingCompleted = (applicationId, data) => async (dispatch, getState, { fetch }) => {
  dispatch({ type: SCHEDULE_COMPLETE_START });
  const { apiVersion } = getState().runtime;
  const { locale } = getState().intl;
  return fetch(
    `${locale}/api/${apiVersion}/application/${applicationId}/scheduling-status/update-scheduling-completed/`,
    {
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRFToken': getCsrfToken(),
      },
      method: 'PATCH',
      body: JSON.stringify(data),
    },
  )
    .then(fetchErrorHandler)
    .then(response => {
      if (response.status === 200) {
        return response;
      }
      const error = new Error(response.statusText);
      error.response = response;
      throw error;
    })
    .then(response => response.json())
    .then(json => {
      dispatch({
        type: SCHEDULE_COMPLETE_SUCCESS,
        payload: json,
      });
    })
    .catch(error => {
      dispatch({
        type: SCHEDULE_COMPLETE_ERROR,
        payload: error,
      });
    });
};
